import React from "react";

export default function Description({ title }) {
  return (
    <div className="px-8 py-4">
      <span>{title}</span>
    </div>
  );
}
